import * as React from "react";
const SvgArrowRight = props => <svg xmlns="http://www.w3.org/2000/svg" width={44} height={44} viewBox="0 0 44 44" {...props}><path d="M32.5 22 12 36V8z" /></svg>;
export default SvgArrowRight;